
import eventBus from '../plugins/eventBus'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CategoriesStore } from '@/store/stores/CategoriesStore'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import { getParameter } from '@/plugins/globals'

import { addToCartSuccess } from '@/plugins/popups'
import { ItemModel } from '@/store/models/ItemModel'
import '@/theme/scss/components/item.scss'
import { CarouselNextLabel, CarouselPrevLabel, carouselOption } from '@/plugins/globalStaticDatas'
import { FavoritesStore } from '@/store/stores/FavoritesStore'

@Component({})
export default class Categories extends Vue {
  @Prop({ default: false, type: Boolean }) isHomePage: boolean
  categories: CategoriesStore = CategoriesStore.getInstance()
  hasLeftCategories: boolean = envConfiguration.hasLeftCategories
  selectedCategory: any = -1
  activeCategory: number = 0

  carouselOption: Object = carouselOption

  nextLabel: any = CarouselNextLabel()
  prevLabel: any = CarouselPrevLabel()

  selectCategory(id: any, event: any) {
    event.stopPropagation()
    this.activeCategory = id
    eventBus.$emit('categories:selected', id)
  }
  selectCategoryHomePage(id: any, event: any) {
    event.stopPropagation()
    this.activeCategory = id
    eventBus.$emit('categories:selected', id)
    this.$router.push({ name: 'Catalog', params: { id: id } }).catch(() => {})
  }

  showSubCategories(id: number) {
    if (this.selectedCategory == id) {
      this.selectedCategory = -1
    } else {
      this.selectedCategory = id
    }
  }

  mounted() {
    this.selectedCategory = this.$route.params.id
    console.log(this.categories.getStore())
    const sectorId = getParameter('sector_id')
    this.categories.loadData(sectorId)
    console.log('categories from store', this.categories.getStore())
  }

  productName(productName: string) {
    if (productName === null) return 'Nuk Ka Emër'
    if (productName.split('').length > 50) {
      return `${productName.split(' ').slice(0, 8).join(' ')}...`
    }
    return productName
  }
}
